import React from 'react'
import './styles.css'

/*const defaultConfig = {
	type: "text",
	placeholder: "",
	name: "input",
	label: ""
};
const newProps = { ...defaultConfig, ...props };
*/

class NuDropCheck extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      selectedOptions :[this.props.value],
      filterOptons:[],
      //item es controlado desde afuera
      //itemSelected :{"value":"","label":""}, //itemSelected":{"value":"","label":"Completo"}
    };

    //------------ para el click outside
    this.wrapperRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }
  //======================= clic outside ==========================
  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }
  
  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
      //alert("You clicked outside of me!");
      //console.log("You clicked outside of me!")
      if(this.state.open===true){
        this.setState({open: false })
      }
    }
  }
  //=================================================
  toggleDropDown = () => {
    console.log( this.state.open)
    this.setState({ open: !this.state.open });
  };
  toggleHide=()=>{
    this.setState({ open: false });
  }
  //-----------------------------------------------
  addItem = (e, item) => {
    e.preventDefault();
    // 👇️ filter with 1 condition
    //console.log(e.target.value);
    console.log(item)

    //this.toggleDropDown()
    const newData = [...this.state.selectedOptions]
    //---si no incluye ya en la seleccion, lo agregamos
    if(!newData.includes(item)){
      
      newData.push(item)
      this.setState({ selectedOptions: newData })
      console.log(newData)
    }
    
    //-------------- simple list

    let filter = this.tabla_filter(newData);
    //console.log(filter)
    //this.props.onClickItem(item);
    //this.props.onSelectOptions(newData);
    this.props.onSelectOptions(newData, filter);
    
  }

  /*filterOptions = this.props.options.filter(option=>
    option.toLowerCase().includes()
  )*/
  removeOpt=(item)=>{
    console.log("removeItem")
    const newData = [...this.state.selectedOptions]
    //buscamos si esta el item
    let index = newData.indexOf(item)
    if(index>=0){
      newData.splice(index,1)
      this.setState({ selectedOptions: newData })
      console.log(newData)
    }
    this.toggleHide()

    let filter = this.tabla_filter(newData);
    this.props.onSelectOptions(newData, filter);
  }
  //-----------------------
  tabla_filter=(newData)=>{
    const filteredB = []; //[]
    newData.forEach(item => {
      filteredB.push( item.value  );
    });
    return  filteredB.toString();
  }
  //-------------------------------------
  /*removeItemOnce(arr, value) {
    var index = arr.indexOf(value);
    if (index > -1) {
      arr.splice(index, 1);
    }
    return arr;
  }*/
  //-------------------------------------
  buscarItem=(value)=>{

    const filtered = this.props.options.filter(item => {
      return item.value == value;
    });
    //console.log(filtered[0]); //sino hay retorna undefined
    //---lo anexamos para ser retornado
    let miItem={value:'', label:''};
    if(miItem!==null){
      miItem = filtered[0]
    }
    return miItem
  }
  //-----------------------------------------------
  render() {
    let itemSelected =  this.buscarItem(this.props.value)
    return (

      <div className="multiselect-dropdown dropdownj" ref={this.wrapperRef} > 
        {
          //JSON.stringify(this.state.selectedOptions )
        }
        {
          //itemSelected.label
          //aqui mostramos la lista de opcionesSeleccionadas
          this.state.selectedOptions.map((item, index)=>(
            <span key={index}
                 className='flex optext' >
              {item.label} 
              <span class="echip-close" onClick={(e) => this.removeOpt(item) }>
                <i className='fa fa-close'></i>
              </span>
            </span>
          ))
        }

        <button className={` ${this.props.classBtn} ` } 
                onClick={ this.toggleDropDown } 
                style={ this.props.styleBtn }
                >
          {/* mostramos texto o icono */}
          {(this.props.iconBtn!=="") &&
              <i className={ this.props.iconBtn}></i>
          }
          { this.props.text }
          
        </button>

      
        <div className="">
          <div 
            className="dropdownj-content"
            tabIndex="0"       
          >
            
            {this.state.open ? (
              <div className="menu" style={{ display: `${this.state.open ? 'block' : 'none'}`}} >
                {
                this.props.options.map((item, index) => (
                  <div  className="item" key={index} 
                        onClick={(e)=> this.addItem(e, item) }>
                   
                    <label>{item.label}</label>
                  </div>
                ))}
              </div>
            ) : null}
          </div>
        </div>
        
      </div>
    );
  }
}


export default NuDropCheck;

// Set default props
NuDropCheck.defaultProps = {
  /* Declare your default Props here */
  classBtn:'btn1 btn-14',
  options:[],
  iconBtn:"",
  styleBtn:{},
  text:'...',
  value:'',
};

/**
 *  <div className="item">
                  <i className="edit icon" /> Edit Post
                </div>
                <div className="item">
                  <i className="delete icon" /> Remove Post
                </div>
                <div className="item">
                  <i className="hide icon" /> Hide Post
                </div>
 * 
 */